import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import Constant from '../../common/constant/Constant';
import { I18n } from 'aws-amplify';

const ButtonSubmitAddHelpDeskTicket = props => {
    const {
        isSoftDelete,
        isDraftMode,
        isEdited,
        isGeneralUserWithGuest,
        setIsShowDialogRestoreTicket,
        createTicketType,
        isDisableButtonDraft,
        isDisableButtonSend,
        handleSubmitSaveDraft,
        handleSubmitCreateTicket,
        onSubmitCreateTicket,
        setDisplayMode,
        argsAll,
        displayMode,
        setDisplayPopupConfirmCancel
    } = props;

    const onChangeViewMode = e => {
        if (displayMode === Constant.DISPLAY_MODE.EDIT && isEdited) {
            return setDisplayPopupConfirmCancel(true);
        }

        setDisplayMode(preMode => {
            if (preMode === Constant.DISPLAY_MODE.EDIT) {
                return Constant.DISPLAY_MODE.VIEW;
            } else {
                return Constant.DISPLAY_MODE.EDIT;
            }
        });
    };

    const renderCreateMode = () => {
        return (
            <div className="col2">
                <div className="itemAddticket btn-addTicket-container">
                    <div className="wrap-btn-add">
                        {!isSoftDelete && (
                            <>
                                {props?.displayMode === Constant.DISPLAY_MODE.EDIT &&
                                    !!isDraftMode && (
                                        <Button
                                            className="btn-send btn-outline-primary btn-hg32 back-to-draft"
                                            variant="contained"
                                            color="primary"
                                            onClick={e => onChangeViewMode(e)}
                                        >
                                            {I18n.get('BUTTON-CANCEL-EDIT')}
                                        </Button>
                                    )}
                                <Button
                                    className="btn-send btn-outline-primary btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    disabled={isDisableButtonDraft}
                                    onClick={handleSubmitSaveDraft}
                                >
                                    {I18n.get('CM-BUTTON-SAVE-AS-DRAFT')}
                                </Button>

                                <Button
                                    className="btn-send btn-primary btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    disabled={isDisableButtonSend}
                                    onClick={handleSubmitCreateTicket(data =>
                                        onSubmitCreateTicket(data, argsAll)
                                    )}
                                >
                                    {createTicketType ===
                                    Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT
                                        ? I18n.get('USER03BTN011')
                                        : I18n.get('USER04BTN001')}
                                </Button>
                            </>
                        )}
                        {renderBtnCompletedDeleteAndRestoreTicket()}
                    </div>
                </div>
            </div>
        );
    };

    const renderBtnCompletedDeleteAndRestoreTicket = () => {
        if (isSoftDelete && isGeneralUserWithGuest) {
            return (
                <Button
                    className="btn-send btn-outline-primary btn-hg32"
                    variant="contained"
                    color="primary"
                    onClick={() => setIsShowDialogRestoreTicket(true)}
                >
                    {I18n.get('HELPDESK_RESTORE')}
                </Button>
            );
        }
    };

    const renderByMode = () => {
        return renderCreateMode();
    };

    return <>{renderByMode()}</>;
};

ButtonSubmitAddHelpDeskTicket.propTypes = {
    isSoftDelete: PropTypes.bool,
    displayMode: PropTypes.string,
    setDisplayMode: PropTypes.func,
    createTicketType: PropTypes.number,
    isDisableButtonSend: PropTypes.bool,
    onSubmitCreateTicket: PropTypes.func,
    handleSubmitCreateTicket: PropTypes.func,
    isDisableButtonDraft: PropTypes.bool,
    handleSubmitSaveDraft: PropTypes.func,
    argsAll: PropTypes.any,
    setIsConfirmDialogObj: PropTypes.func,
    isGeneralUserWithGuest: PropTypes.bool,
    setIsShowDialogRestoreTicket: PropTypes.func,
    isDraftMode: PropTypes.bool,
    isEdited: PropTypes.bool,
    setDisplayPopupConfirmCancel:PropTypes.func
};

export default ButtonSubmitAddHelpDeskTicket;
